import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useZywaveRedirectPageStore } from 'store/pages/quote/zywave-redirect-page/pageStore';
import { RouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { GeneralStatistics } from './GeneralStatistics';
import { StatisticsByProductLines } from './StatisticsByProductLines';

// TESTING_POLICY: CYPRESS_ONLY

export const PageContent: React.FC = observer(() => {
  const pageStore = useZywaveRedirectPageStore();
  const { onComplete, canCompleteStep } = pageStore;

  useEffect(() => {
    void pageStore.getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={pageStore.flowDelegate}
      pageId={RouteV2Id.ZYWAVE_QUOTE_REDIRECT}
      pageHeader={{
        subtitleMaxWidth: '42rem',
      }}
      isPageLoading={pageStore.flowDelegate.isInitialDataLoading}
      pageFooter={{
        onComplete,
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <GeneralStatistics />
      <StatisticsByProductLines />
    </QuoteFlowLayout>
  );
});
